export const commonNoTabOrDrawerRouteProps = {
  showInTab: false,
  showInDrawer: false,
};

export const commonTabRouteProps = {
  showInTab: true,
  showInDrawer: false,
};

export const commonDrawerRouteProps = {
  showInTab: false,
  showInDrawer: true,
};
